module.exports = __webpack_public_path__ + "dashboard/img/play.84b44a6ff44ee7bce936db3b249280e8.svg";